module.exports = __webpack_public_path__ + "img/eneva.4fdd4e8e.png";